exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-wapper[data-v-62a767c6]{cursor:pointer}.star-wapper .star-rated[data-v-62a767c6]{color:#f37336}", ""]);

// exports
